import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '../auth-guard.service';
import {SettingEtaxMenuComponent} from './setting-etax-menu/setting-etax-menu.component';
import {SetPasswordComponent} from './set-password/set-password.component';
import {CompanyProfileComponent} from './company-profile/company-profile.component';
import {GroupCompanyComponent} from './group-company/group-company.component';
import {UserCompanyComponent} from './user-company/user-company.component';
import {CompanyListComponent} from './company-list/company-list.component';
import {SiteListComponent} from './site-list/site-list.component';
import {WatermarkComponent} from './watermark/watermark.component';
import {PackageListComponent} from './package-manager/package-list/package-list.component';
import {PackageDetailComponent} from './package-manager/package-detail/package-detail.component';
import {PromotionListComponent} from "./package-manager/promotion-list/promotion-list.component";
import {PromotionDetailComponent} from "./package-manager/promotion-detail/promotion-detail.component";
import {PdfTemplateListComponent} from "./pdf-template-list/pdf-template-list.component";
import {AllowIpComponent} from './allow-ip/allow-ip.component';
import {AllowClientComponent} from './allow-client/allow-client.component';

const routes: Routes = [
   {
      path: 'admin-tool',
      canActivate: [AuthGuard],
      children: [
         {
            path: 'company-profile/:name',
            component: CompanyProfileComponent
         },
         {
            path: 'company-group',
            component: GroupCompanyComponent
         },
         {
            path: 'company-user',
            component: UserCompanyComponent
         },
         {
            path: 'etax-setting',
            component: SettingEtaxMenuComponent
         },
         {
            path: 'site-list',
            component: SiteListComponent
         },
         {
            path: 'watermark-setting',
            component: WatermarkComponent
         },
         {
            path: 'pdf-template',
            component: PdfTemplateListComponent
         },
         {
            path: 'ip-allow-list',
            component: AllowIpComponent
         },
         {
            path: 'client-allow-list',
            component: AllowClientComponent
         }
      ]
   },
   {
      path: 'company-list',
      component: CompanyListComponent,
      canActivate: [AuthGuard],
   },
   {
      path: 'set-password/:device',
      component: SetPasswordComponent
   },
   {
      path: 'package-manager',
      canActivate: [AuthGuard],
      children: [
         {
            path: 'package-list',
            component: PackageListComponent
         },
         {
            path: 'package-detail',
            component: PackageDetailComponent
         },
         {
            path: 'promotion-list',
            component: PromotionListComponent
         },
         {
            path: 'promotion-detail',
            component: PromotionDetailComponent
         }
      ]
   },
];
@NgModule({
   imports: [RouterModule.forRoot(routes)],
   exports: [RouterModule]
})
export class AdminRoutingModule { }
